import Swiper, { EffectFade, Lazy, Thumbs, Autoplay, Pagination } from 'swiper';

// const thumbnailsSlider = new Swiper('.single-product-slider-thumbnails', {
//     modules: [Autoplay],
//     slidesPerView: 5,
//     watchSlidesVisibility: true,
//     spaceBetween: 8,
//     autoplay: {
//         delay: 5000,
//     },
// });

const singleProductSlider = new Swiper('.single-product-slider', {
    modules: [EffectFade, Lazy, Thumbs, Pagination],
    effect: 'slide',
    autoHeight: true,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
      },
    watchSlidesVisibility: true,
    lazy: {
        preloaderClass: 'single-product-slider-preloader',
    },
});
